import { useTranslation } from 'react-i18next';

import { Alert, Button, Stack } from '@rootsight/ui';

import { RecoveryCodeList } from './RecoveryCodeList';

/**
 * CodesStep shows the recovery codes a first second factor came with. They
 * are shown this once, so the person moves on only by saying they kept them.
 */
export function CodesStep({ codes, onContinue }: { codes: string[]; onContinue: () => void }) {
  const { t } = useTranslation('auth');
  return (
    <Stack gap={4}>
      <Alert tone="warning" title={t('login.codes.title')}>
        {t('login.codes.body')}
      </Alert>
      <RecoveryCodeList codes={codes} />
      <Button variant="primary" size="lg" onPress={onContinue}>
        {t('login.codes.continue')}
      </Button>
    </Stack>
  );
}
